import slices from './slices';

export default {
    ...slices.settingsSlice.actions,
};